import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { ReportOptionsWithUserParams } from '@/services/networkReport/models/reportOptions';
import downloadJsonFile from '@/utils/general/fileDownload/downloadJsonFile';
import { mutationWithFeedback } from '@/utils/toast';
import { trpc } from '@/utils/trpc';
import getNetworkName from '../utils/getNetworkName';
const useGenerateNetworkReport = () => {
  const $ = _c(2);
  const utils = trpc.useUtils();
  let t0;
  if ($[0] !== utils.network.generateNetworkReport) {
    t0 = async (networkId, networks, options) => {
      const report = await mutationWithFeedback({
        mutation: utils.network.generateNetworkReport.fetch({
          networkId,
          options
        }, {
          staleTime: 0
        }),
        successText: "Network report generated",
        errorText: "Failed to generate network report",
        loadingText: "Generating..."
      });
      const networkName = getNetworkName(networks, networkId);
      downloadJsonFile(report, `${networkName.replaceAll(" ", "_")}.report.json`);
    };
    $[0] = utils.network.generateNetworkReport;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default useGenerateNetworkReport;